// custom hook, provides input values and methods to form
import { useState, SyntheticEvent } from 'react';

import { validate } from '@components/library/form/validator';
import { InputsMap, ValidationRules, SelectionValue, SelectOnChangeEvent, InputHandlerFn, InputEvent } from '@components/library/inputs/Input.props';

type SetInputsDispatch = React.Dispatch<React.SetStateAction<InputsMap>>;

const isSelectOnChangeEvent = (event: InputEvent):
  event is SelectOnChangeEvent => !!(event as SelectOnChangeEvent).inputName;

export const useInputs = (): {
  handleBlur: InputHandlerFn;
  handleChange: InputHandlerFn;
  handleFocus: InputHandlerFn;
  inputs: InputsMap | undefined;
  setInputs: SetInputsDispatch;
} => {
  const [inputs, setInputs] = useState<InputsMap | undefined>({});

  const handleChange = (event: InputEvent, validationRules: ValidationRules = {}): void => {
    let name: string;
    let value: string | SelectionValue;
    if (!isSelectOnChangeEvent(event)) {
      const genericEvent: any = event; // eslint-disable-line @typescript-eslint/no-explicit-any
      genericEvent.persist();
      name = genericEvent.target && genericEvent.target.name;
      value = genericEvent.target && genericEvent.target.value;
    } else {
      name = event.inputName;
      value = { value: event.value || '', label: event.label || '' };
    }

    setInputs((prevState) => {
      const updatedState = { ...prevState };

      if (!updatedState[name]) {
        updatedState[name] = {};
      }

      updatedState[name].error = validate(value, validationRules);
      updatedState[name].touched = true;
      updatedState[name].value = value;

      return updatedState;
    });
  };

  const handleBlur = (event: SyntheticEvent, validationRules: ValidationRules = {}): void => { // eslint-disable-line @typescript-eslint/no-unused-vars
    event.persist();
    // Placeholder for blur actions
  };

  const handleFocus = (event: SyntheticEvent, validationRules: ValidationRules = {}): void => { // eslint-disable-line @typescript-eslint/no-unused-vars
    event.persist();
    // Placeholder for blur actions
  };

  return {
    handleBlur,
    handleChange,
    handleFocus,
    inputs,
    setInputs,
  };
};

export default useInputs;
